/*
  ##############################################
  ### BUNDLER
  ### - Shows a "Part of a bundle" banner in the buy section when the current product is in a bundle
  ##############################################
*/

(function() {
    const target = document.getElementById('bundler-target-element');
    if (!target) return;

    /* ---
    Bundle ad banner
    --- */

    document.addEventListener('bundler:loaded', () => {
        if (!window.bndlr || !window.bndlr.getBundles) return;

        const bundles = window.bndlr.getBundles();
        if (!bundles || !bundles.length) return;

        const productId = String(ShopifyAnalytics.meta.product.id);
        if (!productId) return;

        const matching = bundles.filter((b) => b.products && b.products.hasOwnProperty(productId));
        if (!matching.length) return;

        const banner = document.querySelector('.in-a-bundle-banner');
        if (!banner) return;

        const textEl = banner.querySelector('.in-a-bundle-banner__text');
        const bundle = matching[0];

        let discount = '';
        if (bundle.discount_type === 'percentage' && bundle.percentage_value) {
            discount = bundle.percentage_value + '% off';
        } else if (bundle.discount_type === 'fixed_amount' && bundle.fixed_amount_value) {
            discount = '£' + bundle.fixed_amount_value + ' off';
        }

        const discountText = discount ? '<span>' + discount + '</span>' : 'save';

        textEl.innerHTML = matching.length === 1 ? 'Part of our ' + bundle.title + ', ' + discountText + ' when bought together!' : 'This product features in ' + matching.length + ' bundles, buy together and save!';

        banner.style.display = '';

        target.innerHTML = "<h2>Product Bundles</h2>" + target.innerHTML;
    });
})();